import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.25 14.75H11.75C12.5784 14.75 13.25 14.0784 13.25 13.25V5.46604C13.25 5.32817 13.1931 5.19642 13.0927 5.10194L9.14439 1.3859C9.05164 1.29861 8.92908 1.25 8.80171 1.25H4.25C3.42157 1.25 2.75 1.92157 2.75 2.75V13.25C2.75 14.0784 3.42157 14.75 4.25 14.75Z"
            fill="#DEDEDE"
            stroke="#818181"
            strokeWidth="0.75"
        />
        <rect fill="#3C3C3C" height="5" rx="1" width="10.5" x="1" y="8.5" />
        <path
            d="M8.75 1.25V5C8.75 5.27614 8.97386 5.5 9.25 5.5H13.25"
            stroke="#818181"
            strokeWidth="0.75"
        />
        <path
            d="M2 12.6707H2.8064V11.7412H3.35132C4.05884 11.7412 4.51587 11.3062 4.51587 10.6272V10.6228C4.51587 9.94385 4.05884 9.5 3.35132 9.5H2V12.6707ZM3.15796 10.1174C3.49854 10.1174 3.70068 10.2932 3.70068 10.6228V10.6272C3.70068 10.9568 3.49854 11.1348 3.15796 11.1348H2.8064V10.1174H3.15796Z"
            fill="#FDFDFD"
        />
        <path
            d="M5.00902 12.6707H6.29662C7.25243 12.6707 7.81713 12.0796 7.81713 11.0667V11.0623C7.81713 10.0537 7.25243 9.5 6.29662 9.5H5.00902V12.6707ZM5.81542 12.0203V10.1504H6.19115C6.69872 10.1504 6.99755 10.4712 6.99755 11.0645V11.0688C6.99755 11.7017 6.7163 12.0203 6.19115 12.0203H5.81542Z"
            fill="#FDFDFD"
        />
        <path
            d="M8.34324 12.6707H9.14964V11.4885H10.3779V10.8711H9.14964V10.1482H10.501V9.5H8.34324V12.6707Z"
            fill="#FDFDFD"
        />
    </svg>
);

export default Icon;
